import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { selectSports } from '../../../store/selectors/sport.selectors';
import { createTeam } from '../../../store/actions/teams.actions';

@Component({
  selector: 'app-manage-teams',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, DropdownModule],
  templateUrl: './manage-teams.component.html',
  styleUrl: './manage-teams.component.scss',
})
export class ManageTeamsComponent implements OnInit {
  private http = inject(HttpClient);
  private store = inject(Store);
  imageUrl: string = 'https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg';
  selectedFile: File | null = null;
  loading = false;
  teamForm!: FormGroup;
  sports = toSignal(this.store.select(selectSports));
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.teamForm = this.fb.group({
      name: ['', Validators.required],
      logo_url: [''],
      logo_id: [''],
      sport: ['', Validators.required],
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.teamForm.patchValue({ logo_url: "selected" });
      this.selectedFile = file;
    }
  }

  onSubmit(): void {
    if (this.teamForm.invalid) {
      this.teamForm.markAllAsTouched();
      return;
    }
    if (this.teamForm.value.logo_id) {
      let logo_id_link = "";
      if (this.teamForm.value.logo_id) {
        if (this.teamForm.value.sport === "1") {
          logo_id_link = `https://media.api-sports.io/football/teams/${this.teamForm.value.logo_id}.png`
        } else if (this.teamForm.value.sport === "3") {
          logo_id_link = `https://media.api-sports.io/basketball/teams/${this.teamForm.value.logo_id}.png`
        } else if (this.teamForm.value.sport === "4") {
          logo_id_link = `https://media.api-sports.io/rugby/teams/${this.teamForm.value.logo_id}.png`
        }
      }
      this.store.dispatch(createTeam({
        team: {
          name: this.teamForm.value.name,
          logo_url: this.teamForm.value.logo_url,
          logo_id: logo_id_link,
          sport: this.teamForm.value.sport
        }
      }));
      this.teamForm.reset();
      return;
    }
    if (!this.selectedFile) {
      return;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('upload_preset', 'analytix');
    const cloudinaryUrl = 'https://api.cloudinary.com/v1_1/ds9embh9b/image/upload';
    this.http.post(cloudinaryUrl, formData).subscribe({
      next: (res: any) => {
        const imageUrl = res.secure_url;
        this.imageUrl = imageUrl;
        this.teamForm.patchValue({ logo_url: imageUrl });
        let logo_id_link = "";
        if (this.teamForm.value.logo_id) {
          if (this.teamForm.value.sport === 1) {
            logo_id_link = `https://media.api-sports.io/football/teams/${this.teamForm.value.logo_id}.png`
          } else if (this.teamForm.value.sport === 3) {
            logo_id_link = `https://media.api-sports.io/basketball/teams/${this.teamForm.value.logo_id}.png`
          } else if (this.teamForm.value.sport === 4) {
            logo_id_link = `https://media.api-sports.io/rugby/teams/${this.teamForm.value.logo_id}.png`
          }
        }
        console.log(this.teamForm.value);
        this.store.dispatch(createTeam({
          team: {
            ...this.teamForm.value,
            logo_id: logo_id_link
          }
        }));
        this.loading = false;
        this.teamForm.reset();
      },
      error: (err) => {
        this.loading = false;
        this.teamForm.reset();
      },
    });
  }
}
